import { SupervisorEmailCTA } from "../../../../src/components/ctas/supervisor_email";
import { SharedSpacesCosponsors } from "../../../../src/components/shared_spaces_cosponsors.js";
import * as React from 'react';
export default {
  SupervisorEmailCTA,
  SharedSpacesCosponsors,
  React
};